// extracted by mini-css-extract-plugin
export default {"cls1":"ContentFeedback-cls1_Wlj","cls2":"ContentFeedback-cls2_Mtt ContentFeedback-cls1_Wlj"};